module.exports = __webpack_public_path__ + "media/orderscreen.a0ca6ffa.webm";